<script>
import Service from '@/services/ApiService'
import Distance from '@/mixins/Distance'

export default {
  mixins: [
    Service,
    Distance
  ],
  methods: {
    getDiscounts () {
      return new Promise((resolve, reject) => {
        let filters = [
          {
            id: -1,
            name: 'alles'
          }
        ]
        let discounts = []

        Service.get('discount/getall').then(res => {
          res.data.forEach(branche => {
            if (branche.id !== 25) {
              filters.push({ id: branche.id, name: branche.name })
              branche.surroundings.data.forEach(surrounding => {
                let defaultData = {}
                let customData = null
                let pdfData = null
                const discountData = surrounding.discounts.data[0]
                const discountable = discountData.discountable.data
                if (discountData.discountable_type === 'enjoj\\discount\\HomeMadeDiscount') {
                  discountable.products.data.forEach(product => {
                    // eslint-disable-next-line
                    const { title, brand, description, image_url, id } = product
                    defaultData = {
                      branche: branche.id,
                      surrounding: {
                        id: surrounding.id,
                        name: surrounding.name,
                        distance: this.getDistance(surrounding.gps),
                        logo_url: surrounding.logoUrl
                      },
                      info: {
                        id: discountData.id,
                        title: discountData.title
                      },
                      title,
                      image_url,
                      date: { start: product.date.data.start, end: product.date.data.end }
                    }
                    const priceProduct = product.price.data
                    let price
                    if (priceProduct.old !== 0 && priceProduct.new !== 0) {
                      price = { old: priceProduct.old, new: priceProduct.new }
                    } else {
                      price = null
                    }
                    customData = {
                      id,
                      description,
                      price,
                      brand
                    }
                    discounts.push({
                      ...defaultData,
                      customData,
                      pdfData
                    })
                  })
                }

                if (discountData.discountable_type === 'enjoj\\discount\\PdfDiscount') {
                  defaultData = {
                    branche: branche.id,
                    surrounding: {
                      id: surrounding.id,
                      name: surrounding.name,
                      distance: this.getDistance(surrounding.gps),
                      logo_url: surrounding.logoUrl
                    },
                    info: {
                      id: discountData.id,
                      title: discountData.title
                    },
                    title: surrounding.name,
                    image_url: surrounding.logoUrl,
                    date: { start: discountable.start_date, end: discountable.end_date }
                  }
                  pdfData = {
                    pdf_url: discountable.url
                  }
                  discounts.push({
                    ...defaultData,
                    customData,
                    pdfData
                  })
                }
              })
            }
          })
          const discountSorted = discounts.sort((x, y) => x.surrounding.distance - y.surrounding.distance)
          this.$store.commit('setDiscountFilter', filters)
          this.$store.commit('setDiscounts', discountSorted)
          resolve()
        }).catch(err => reject(err))
      })
    },
    getDiscountIndex (params, discounts) {
      return new Promise((resolve, reject) => {
        if (params.slug) {
          const splitted = params.slug.split('-')
          const id = Number(splitted[splitted.length - 1])

          resolve(discounts.findIndex(discount => discount.customData ? id === discount.customData.id : null))
        } else {
          const splitted = params.discount.split('-')
          const id = Number(splitted[splitted.length - 1])

          resolve(discounts.findIndex(discount => !discount.customData ? id === discount.info.id : null))
        }
      })
    }
  }
}
</script>
